import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { SessionAnalyticsComponent } from '@go-modules/components/feedback-session/session-analytics/session-analytics.component';
export { SessionAnalyticsModule } from '@go-modules/components/feedback-session/session-analytics/session-analytics.module';

// TODO - remove when feedbackSession ngx STAB-680
export const ngxSessionAnalyticsModule = angular.module('ngxSessionAnalyticsModule', [])
	.directive('ngxSessionAnalytics', downgradeComponent({ component: SessionAnalyticsComponent }))
	.name;
